import { NavLink } from 'react-router-dom';
import { useStaticPages } from '../hooks/useStaticPages';

/**
 * Left sidebar inside a static sub-project. Lists every `.html` file under the project's content root.
 * Clicking an entry updates the URL so `StaticProjectPage` swaps the iframe's `src`.
 */
export default function StaticTocSidebar({ slug }: { slug: string }) {
  const { data, isLoading, error } = useStaticPages(slug);
  return (
    <aside className="sidebar" data-testid="static-toc-sidebar">
      <div className="sidebar__scroll">
        {isLoading ? <div className="empty-state">Loading...</div> : null}
        {error ? <div className="empty-state">Failed to load pages.</div> : null}
        {data && data.length === 0 ? <div className="empty-state">(no pages)</div> : null}
        {data && data.length > 0 ? (
          <ul>
            {data.map((p) => (
              <li key={p.path} data-testid={`static-page-${p.path}`}>
                <NavLink
                  to={`/${slug}/${encodePath(p.path)}`}
                  end
                  className={({ isActive }) => (isActive ? 'active' : '')}
                >
                  {p.name}
                </NavLink>
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </aside>
  );
}

/** Per-segment URL-encode a slash-separated path. Preserves separators; encodes spaces and other chars. */
function encodePath(path: string): string {
  return path.split('/').map(encodeURIComponent).join('/');
}
